import { authAction } from "./auth/authAction";
import { boMonActions } from "./category/boMonActions";
import { chuDeActions } from "./category/chuDeActions";
import { donViHanhChinhActions } from "./category/donViHanhChinhActions";
import { giaoVienActions } from "./category/giaoVienActions";
import { heActions } from "./category/heActions";
import { hocKyDangKyActions } from "./category/hocKyDangKyActions";
import { khoaActions } from "./category/khoaActions";
import { monHocActions } from "./category/monHocActions";
import { mucTriNangActions } from "./category/mucTriNangActions";
import { toChucThiActions } from "./category/toChucThiActions";
import { cauHoiActions } from "./cau-hoi/cauHoiActions";
import { nhomCauHoiActions } from "./cau-hoi/nhomCauHoiActions";
// import { quyetDinhActions } from "./category/quyetDinhActions";
import { layoutActions } from "./common/layoutActions";
import { cauTrucDeThiActions } from "./de-thi/cauTrucDeThiActions";
import { chuDeThiActions } from "./de-thi/de-thi-in/chuDeThiInAction";
import { deThiInAction } from "./de-thi/de-thi-in/deThiInAction";
import { nhomDeThiActions } from "./de-thi/de-thi-in/nhomDeThiInAction";
import { deThiActions } from "./de-thi/deThiAction";
import { dotTaoDeActions } from "./de-thi/dotTaoDeActions";
import { quanLyHocPhanActions } from "./quyet-dinh/quanLyHocPhanActions";

export const rootActions = {
  auth: authAction,
  common: {
    layout: layoutActions,
  },
  category: {
    hocKyDangKy: hocKyDangKyActions,
    mucTriNang: mucTriNangActions,
    monHoc: monHocActions,
    boMon: boMonActions,
    khoa: khoaActions,
    donViHanhChinh: donViHanhChinhActions,
    giaoVien: giaoVienActions,
    chuDe: chuDeActions,
    toChucThi: toChucThiActions,
    he: heActions,
  },
  cauHoi: {
    nhomCauHoi: nhomCauHoiActions,
    cauHoi: cauHoiActions,
  },
  quyetDinh: {
    quanLyHocPhan: quanLyHocPhanActions,
  },
  deThi: {
    dotTaoDe: dotTaoDeActions,
    cauTrucDeThi: cauTrucDeThiActions,
    deThi: deThiActions,
    deThiIn: {
      nhomDeThiIn: nhomDeThiActions,
      chuDeThiIn: chuDeThiActions,
      deThiIn: deThiInAction,
    },
  },
};
